import PasswordField from './styled';

export default PasswordField;
